import React, { useEffect, useState, memo } from "react";
import { useAuthModal } from "core/context";
import Icon from "core/assets/icons";
import { useReactionComment, useReactionPost } from "modules/Community/hooks";

export type IProps = {
  active?: boolean,
  id?: number,
  countLike?: number,
  onChange?: (id: number, state: boolean) => void,
  type?: 'post' | 'comment',
  className?: string;
  reload?: (cb: any, id?: any) => void;
  viewOnly?: boolean;
  idComment?: number;
  tab?: string;
};

const CLikeComunity = ({
  id,
  onChange,
  active = false,
  type = 'post',
  className,
  reload,
  countLike = 0,
  viewOnly = false,
  idComment,
  tab,
}: IProps) => {
  const { openModal, token } = useAuthModal();
  const { handleReactionPost } = useReactionPost()
  const { handleReactionComment } = useReactionComment()
  const [ stateActive, setStateActive ] = useState<boolean>(active);
  const [ countHeart, setCountHeart ] = useState<number>(countLike);


  console.log("active", active);
  useEffect(() => {
    setStateActive(active)
  }, [active, id])

  useEffect(() => {
    setCountHeart(countLike)
  }, [countLike])

  const toggleFavorite = () => {
    if(viewOnly){
      return
    }
    onChange?.(id || 0, !stateActive)
    if(idComment && id){
      handleReactionComment({
        id: String(id),
        stateActive: !stateActive,
        comment_id: idComment,
        tab: tab
      })
    }else {
      handleReactionPost({
        id: String(id),
        stateActive: !stateActive,
        reaction: 'LIKE',
        tab: tab
      })
    }
    
    let countData = countHeart
    if(!stateActive){
      countData = countData + 1
      setCountHeart(countData)
    }else {
      countData = countData - 1
      setCountHeart(countData > 0 ? countData : 0)
    }
    setStateActive((p: boolean) => !p)
  }

  const _handleClickNote = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (!token) {
      openModal(() => {
        reload?.((newState: boolean) => {
          if (!newState) {
            document.getElementById(`CLikeComunity-${type}-${idComment || id}`)?.click()
          }
        }, idComment);
      });
      return;
    }

    toggleFavorite();
  };

  console.log("stateActive", stateActive);
  

  return (
    <>
      {type === 'post' ? (
        <span
          className={`flex items-center ${className}`}
          onClick={_handleClickNote}
          id={`CLikeComunity-${type}-${idComment || id}`}
        >
          <img className="mr-[5px]" src={viewOnly ? Icon.HeartView : (stateActive ? Icon.HeartActive : Icon.Heart)} alt={'favorite'} />
          <label className={`text-[11px] text-[#333333] ${viewOnly ? ' !text-[#777777]' : ''}`}>
            {countHeart}
          </label>
        </span>
      ) : (
        <span
          className={`flex items-center  ${className}`}
          onClick={_handleClickNote}
          id={`CLikeComunity-${type}-${idComment || id}`}
        >
          <label className={`text-[11px] text-[#333333] mr-[5px] ${viewOnly ? ' !text-[#777777]' : ''}`}>{countHeart}</label>
          <img src={viewOnly ? Icon.HeartView : (stateActive ? Icon.HeartActive : Icon.Heart)} alt={'favorite'} />
        </span>
      )}
    </>
  );
};


export default memo(CLikeComunity);
